import { render, staticRenderFns } from "./voucher-list.vue?vue&type=template&id=70661a54&lang=html&"
import script from "./voucher-list.vue?vue&type=script&lang=js&"
export * from "./voucher-list.vue?vue&type=script&lang=js&"
import style0 from "./voucher-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports